import React, { Component } from 'react';
import BaseComponent from '../../../components/system/base';
class Symbol extends BaseComponent {
  render() {
    return(
      <img className={"Symbol " + this.props.name} src={this.props.src} alt={this.props.name} style={{'top': this.props.positionY}} />
    )
  }
}

export default Symbol;


// WEBPACK FOOTER //
// ./src/content/winPrize/slotComponents/Symbol.js